import { MockFactory } from '@tino-frontend/mocks'

type GenericErrorMockType = {
  message: string
}

export const genericErrorMock = new MockFactory<GenericErrorMockType>({
  message: 'Error generic message',
})
